module.exports = __webpack_public_path__ + "static/media/S1N8-4.05d8d9a9.svg";